import { http } from "../http/Http";
import { ServiceResponse, GetByFiltersArguments, LogitudeLookupModel } from "../models";

export class CardService {

    getByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<LogitudeLookupModel[]>> => {
        const { data } = await http.post<ServiceResponse<LogitudeLookupModel[]>>("Card/GetByFilters", apiQueryFilter);
        return data;
    };

    getById = async (id: number): Promise<LogitudeLookupModel> => {
        const { data } = await http.get<LogitudeLookupModel>(("Card/GetById/" + id?.toString()));
        return data;
    };
}
